import "core-js/modules/es6.function.name";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    ref: "modal",
    attrs: {
      "width": 640,
      "title": _vm.title
    },
    model: {
      value: _vm.modalVisible,
      callback: function callback($$v) {
        _vm.modalVisible = $$v;
      },
      expression: "modalVisible"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "myform",
    attrs: {
      "model": _vm.data,
      "rules": _vm.rules,
      "label-width": 100,
      "showMessage": false,
      "autocomplete": "off",
      "novalidate": ""
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "name",
      "label": "角色名称"
    }
  }, [_c('IInput', {
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('name');
      }
    },
    model: {
      value: _vm.data.name,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "name", $$v);
      },
      expression: "data.name"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "prop": "permissions",
      "label": "角色权限"
    }
  }, [_c('CheckboxGroup', {
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('permissions');
      }
    },
    model: {
      value: _vm.data.permissions,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "permissions", $$v);
      },
      expression: "data.permissions"
    }
  }, _vm._l(_vm.allPermissions, function (p) {
    return _c('Checkbox', {
      key: p.id,
      attrs: {
        "label": p.id
      }
    }, [_vm._v(_vm._s(p.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "prop": "max_point_num",
      "label": "最大试用点数"
    }
  }, [_c('IInput', {
    attrs: {
      "type": "number"
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('max_point_num');
      }
    },
    model: {
      value: _vm.data.max_point_num,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "max_point_num", $$v);
      },
      expression: "data.max_point_num"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "prop": "max_trial_days",
      "label": "最大试用天数"
    }
  }, [_c('IInput', {
    attrs: {
      "type": "number"
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('max_trial_days');
      }
    },
    model: {
      value: _vm.data.max_trial_days,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "max_trial_days", $$v);
      },
      expression: "data.max_trial_days"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "产品明细"
    }
  }, [_c('RadioGroup', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: _vm.data.all_products,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "all_products", $$v);
      },
      expression: "data.all_products"
    }
  }, [_c('Radio', {
    attrs: {
      "label": 1
    }
  }, [_c('Icon', {
    attrs: {
      "type": "social-apple"
    }
  }), _c('span', [_vm._v("所有产品")])], 1), _c('Radio', {
    attrs: {
      "label": 0
    }
  }, [_c('Icon', {
    attrs: {
      "type": "social-android"
    }
  }), _c('span', [_vm._v("选择以下产品")])], 1)], 1), _c('div', {
    staticStyle: {
      "border-bottom": "1px solid #e9e9e9",
      "padding-bottom": "6px",
      "margin-bottom": "6px"
    }
  }, [_c('Checkbox', {
    attrs: {
      "disabled": _vm.data.all_products === 1,
      "indeterminate": _vm.indeterminate,
      "value": _vm.checkAll
    },
    nativeOn: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.handleCheckAll.apply(null, arguments);
      }
    }
  }, [_vm._v("全选（不含今后新增产品）")]), _c('Input', {
    staticStyle: {
      "float": "right",
      "width": "200px"
    },
    attrs: {
      "disabled": _vm.data.all_products === 1,
      "placeholder": "请输入关键字",
      "clearable": "",
      "suffix": "ios-search"
    },
    on: {
      "on-change": _vm.onSearchProdTextChange
    },
    model: {
      value: _vm.searchProdText,
      callback: function callback($$v) {
        _vm.searchProdText = $$v;
      },
      expression: "searchProdText"
    }
  })], 1), _c('div', {
    staticClass: "ivu-checkbox-group ivu-checkbox-default"
  }, _vm._l(_vm.showProducts, function (item, index) {
    return _c('Checkbox', {
      key: index,
      attrs: {
        "disabled": _vm.data.all_products === 1
      },
      on: {
        "on-change": _vm.onCheckedChange
      },
      model: {
        value: item._checked,
        callback: function callback($$v) {
          _vm.$set(item, "_checked", $$v);
        },
        expression: "item._checked"
      }
    }, [_vm._v(_vm._s(item.label))]);
  }), 1)], 1)], 1), _c('template', {
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "loading": _vm.loading,
      "disabled": !_vm.isFormValid
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("确定")]), _c('Button', {
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };